import { Lightning, Utils } from '@lightningjs/sdk';
import { Theme } from '../config/theme';

export class ShowPasswordButton extends Lightning.Component {
  static _template() {
    return {
      w: 80,
      h: 80,
      Background: {
        w: w => w,
        h: h => h,
        rect: true,
        color: Theme.Colors.Login.ShowPasswordIcon.focused,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: 40,
        },
        alpha: 0,
      },
      ShowPasswordIcon: {
        mount: 0.5,
        x: w => w / 2,
        y: h => h / 2,
        src: Utils.asset('images/login/eye-regular.png'),
        alpha: 1,
      },
      HidePasswordIcon: {
        mount: 0.5,
        x: w => w / 2,
        y: h => h / 2,
        src: Utils.asset('images/login/eye-slash-regular.png'),
        alpha: 0,
      },
    };
  }

  _focus() {
    this.tag('Background').setSmooth('alpha', 1);
  }

  _unfocus() {
    this.tag('Background').setSmooth('alpha', 0);
  }

  _handleEnter() {
    if (this.tag('ShowPasswordIcon').alpha) {
      this.tag('ShowPasswordIcon').setSmooth('alpha', 0);
      this.tag('HidePasswordIcon').setSmooth('alpha', 1);
      this.signal('onActivate', false);
    } else {
      this.tag('ShowPasswordIcon').setSmooth('alpha', 1);
      this.tag('HidePasswordIcon').setSmooth('alpha', 0);
      this.signal('onActivate', true);
    }
  }
}
